// extracted by mini-css-extract-plugin
module.exports = {"register":"RegisterUser_register__1aStg","input":"RegisterUser_input__1BMoa","checkbox":"RegisterUser_checkbox__35lh_","button":"RegisterUser_button__3veLP"};